import React, { useState } from 'react';
import { Form, Dropdown } from 'react-bootstrap';
import dotsLogo from '../../../img/three_points.svg';

import styleToggle from './CustomToggle.module.less';

export const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href="a"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

export const CustomMenu = React.forwardRef(
  ({
    children, style, className, 'aria-labelledby': labeledBy, filtered,
  }, ref) => {
    const [value, setValue] = useState('');

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        {filtered ? (
          <Form.Control
            autoFocus
            className="mx-3 my-2 w-auto"
            placeholder="Type to filter..."
            onChange={(e) => setValue(e.target.value)}
            value={value}
          />
        ) : <div />}
        <ul className={styleToggle.listUnstyled}>
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value),
          )}
        </ul>
      </div>
    );
  },
);
